import { Component } from '@angular/core';

@Component({
  selector: 'web-history-shimmer',
  templateUrl: './history-shimmer.component.html',
  styleUrls: ['./history-shimmer.component.scss']
})
export class HistoryShimmerComponent {

}
